/**
 * The build's own version, resolved once at module load.
 *
 * `git describe --tags --always --dirty` is the single source: on a tagged
 * commit it yields the release (`v1.2.0`), off one it yields the short SHA, and
 * in between it yields both (`v1.2.0-3-gabc1234`). The npm `start`/`build`
 * scripts run it and hand the result to CRA as REACT_APP_VERSION — see
 * client/package.json.
 *
 * A Docker build has no `.git` in its context, so compose passes the value the
 * *host* computed as a build arg. The scripts' `${REACT_APP_VERSION:-...}`
 * default is what keeps a failed in-container `git` from clobbering it.
 */

// What `--always` falls back to: an abbreviated object name, optionally marked
// dirty. Matching this rather than "looks like a tag" is deliberate — a tag can
// be almost anything, but a SHA is always lowercase hex.
const BARE_COMMIT = /^[0-9a-f]{7,40}(-dirty)?$/;

const withV = (s) => (s.startsWith('v') ? s : `v${s}`);

export function formatVersion(describe, pkgVersion) {
  const described = String(describe || '').trim();
  if (described) {
    // A bare SHA gets a label: "Robotrons 5c152ec" reads like a release number
    // that went wrong, "Robotrons build 5c152ec" reads like what it is.
    return BARE_COMMIT.test(described) ? `build ${described}` : withV(described);
  }

  const packaged = String(pkgVersion || '').trim();
  return packaged ? withV(packaged) : 'dev build';
}

export const APP_VERSION = formatVersion(
  process.env.REACT_APP_VERSION,
  process.env.REACT_APP_PKG_VERSION,
);

export default APP_VERSION;
